import { CallRecordsPage } from "./callRecords";

export const CallRecords = CallRecordsPage;
